import {
    UsersApiService,
    QueryParams,
    CreateUserPayload,
    UpdateUserPayload,
    SortCriterion
} from '../../Types/Users';
import apiClient from '../client';

const ENDPOINT = '/user';

const formatSortParams = (sortCriteria?: SortCriterion[]): string | undefined => {
    if (!sortCriteria || sortCriteria.length === 0) return undefined;
    return sortCriteria
        .map((criterion) => `${String(criterion.field)}:${criterion.order}`)
        .join(',');
};

export const usersApi: UsersApiService = {
    getList: (params: QueryParams) => {
        const { sort, ...otherParams } = params;
        const formattedSort = formatSortParams(sort);

        // Combine all parameters for the axios request.
        // Axios will automatically convert this object into URL query parameters.
        // e.g., { page: 1, sort: 'price:desc' } becomes ?page=1&sort=price:desc
        const requestParams = {
            ...otherParams,
            ...(formattedSort && { sort: formattedSort }) // Add sort only if it exists
        };

        return apiClient.get(ENDPOINT, { params: requestParams });
    },
    getDetail: (id: number) => apiClient.get(`${ENDPOINT}/${id}`),
    create: (payload: CreateUserPayload) => apiClient.post(ENDPOINT, payload),
    update: (id: number, payload: UpdateUserPayload) => apiClient.put(`${ENDPOINT}/${id}`, payload),
    delete: (id: number) => apiClient.delete(`${ENDPOINT}/${id}`),
    getProfile: () => apiClient.get(`${ENDPOINT}/profile`)
};
